// src/__business/components/campaign/promo/_product/promoPage/attract/templates/customization/tabs/ConfirmAddressModal.js
import React from 'react';
import { Modal, Box, Typography, Button, IconButton, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    p: 0,
    overflowY: 'auto',
};

const detailsBoxStyle = {
    bgcolor: '#f7f7fa',
    borderRadius: 2,
    p: 2,
    mb: 2,
    mt: 1,
};

const ConfirmAddressModal = ({
    open,
    onClose,
    selectedAddressDetails,
    onConfirm
}) => (
    <Modal open={open} onClose={onClose}>
        <Box sx={style}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, pb: 1 }}>
                <Typography variant="h6" sx={{ fontWeight: 700, color: '#222' }}>
                    Confirm Selected Address
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </Box>
            <Divider />
            <Box sx={{ p: 2 }}>
                {selectedAddressDetails ? (
                    <Box sx={detailsBoxStyle}>
                        <Typography variant="body1" sx={{ mb: 1 }}>
                            <b>Address:</b> {selectedAddressDetails.formatted_address}
                        </Typography>
                        <Typography variant="body2"><b>Street:</b> {selectedAddressDetails.street}</Typography>
                        <Typography variant="body2"><b>Area:</b> {selectedAddressDetails.area}</Typography>
                        <Typography variant="body2"><b>Province:</b> {selectedAddressDetails.province}</Typography>
                        <Typography variant="body2"><b>City:</b> {selectedAddressDetails.city}</Typography>
                        <Typography variant="body2"><b>Barangay:</b> {selectedAddressDetails.barangay}</Typography>
                    </Box>
                ) : (
                    <Typography color="text.secondary">Loading address details...</Typography>
                )}
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    sx={{ mt: 2, py: 1.2, fontWeight: 600, fontSize: 16, borderRadius: 2 }}
                    onClick={onConfirm}
                    disabled={!selectedAddressDetails}
                >
                    Confirm
                </Button>
            </Box>
        </Box>
    </Modal>
);

export default ConfirmAddressModal;